import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'environments/environment';

@Injectable()
export class MyCookieService 
{
  youtube: boolean = false;
  vimeo: boolean = false;
  google: boolean = false;
  token: boolean = false;
  cPref: boolean = false;
  change: boolean = false;
  reloaded: boolean = false;

  constructor(private cookieService: CookieService) {
    if(this.cookieService.check('c_pref')){
      let obj = JSON.parse(this.cookieService.get('c_pref'));
      if(obj.token != undefined){
        this.setToken(obj.token);
      }
      if(obj.google != undefined){
        this.setGoogle(obj.google);
      }
      if(obj.youtube != undefined){
        this.setYoutube(obj.youtube);
      }
      /*
      if(obj.vimeo != undefined){
        this.setVimeo(obj.vimeo);
      } */
      this.setCPref(true);
    }
  }

  abilitaTutti() {
    this.setGoogle(true);
    this.setToken(true);
    this.setCPref(true);
    this.setYoutube(true);
    //this.setVimeo(true);
    this.cookieService.set('c_pref', '{"token":true,"google":true,"youtube":true}', 365, '/');
  }

  disabilitaTutti() {
    this.setGoogle(false);
    this.setToken(false);
    this.setCPref(false);
    this.setYoutube(false);
    //this.setVimeo(false);
    this.cookieService.deleteAll();
  }

  setGoogle(onOff: boolean) 
  { 
    if(this.google === true && onOff === false){
      this.change = true;
    }
    this.google = onOff;
    if(this.cPref){
      if(this.cookieService.check('c_pref')){
        let obj = JSON.parse(this.cookieService.get('c_pref'));
        obj.google = onOff;
        this.cookieService.set('c_pref', JSON.stringify(obj), 365, '/');
      } else {
        let obj: {google: boolean};
        obj.google = onOff;
        this.cookieService.set('c_pref', JSON.stringify(obj),365, '/');
      }
    }

    if(!this.google){
      this.cookieService.delete('1P_JAR', '/', '.google.com');
      this.cookieService.delete('1P_JAR', '/', '.gstatic.com');
      this.cookieService.delete('APISID', '/', '.google.com');
      this.cookieService.delete('CONSENT', '/', '.google.com');
      this.cookieService.delete('CONSENT', '/', '.gstatic.com');
      this.cookieService.delete('HSID', '/', '.google.com');
      this.cookieService.delete('NID', '/', '.google.com');
      this.cookieService.delete('SAPISID', '/', '.google.com');
      this.cookieService.delete('SID', '/', '.google.com');
      this.cookieService.delete('SIDCC', '/', '.google.com');
      this.cookieService.delete('SSID', '/', '.google.com');
      this.cookieService.delete('_ga', '/', 'www.google.com');
      this.cookieService.delete('UULE', '/', 'www.google.com');
      this.cookieService.delete('DV', '/', 'www.google.com');
      if(environment.test_env) {
        this.cookieService.delete('_ga', '/', '.tc-web.it');
        this.cookieService.delete('_gat', '/', '.tc-web.it');
        this.cookieService.delete('_gid', '/', '.tc-web.it');
      } else if (environment.production) {
        this.cookieService.delete('_ga', '/', '.casanelweb.it');
        this.cookieService.delete('_gat', '/', '.casanelweb.it');
        this.cookieService.delete('_gid', '/', '.casanelweb.it');
      }
    }
  }

  setYoutube(onOff: boolean) 
  { 
    if(this.youtube === true && onOff === false){
      this.change = true;
    }
    this.youtube = onOff;
    if(this.cPref){
      if(this.cookieService.check('c_pref')){
        let obj = JSON.parse(this.cookieService.get('c_pref'));
        obj.youtube = onOff;
        this.cookieService.set('c_pref', JSON.stringify(obj), 365, '/');
      } else {
        let obj: {youtube: boolean};
        obj.youtube = onOff;
        this.cookieService.set('c_pref', JSON.stringify(obj),365, '/');
      }
    }

    if(!this.youtube){
      this.cookieService.delete('APISID', '/', '.youtube.com');
      this.cookieService.delete('HSID', '/', '.youtube.com');
      this.cookieService.delete('LOGIN_INFO', '/', '.youtube.com');
      this.cookieService.delete('PREF', '/', '.youtube.com');
      this.cookieService.delete('SAPISID', '/', '.youtube.com');
      this.cookieService.delete('SID', '/', '.youtube.com');
      this.cookieService.delete('SIDCC', '/', '.youtube.com');
      this.cookieService.delete('SSID', '/', '.youtube.com');
      this.cookieService.delete('VISITOR_INFO1_LIVE', '/', '.youtube.com');
      this.cookieService.delete('YSC', '/', '.youtube.com');
      this.cookieService.delete('GPS', '/', '.youtube.com');
    }
  }

  setVimeo(onOff: boolean) 
  { 
    if(this.vimeo === true && onOff === false){
      this.change = true;
    }
    this.vimeo = onOff;
    if(this.cPref){
      if(this.cookieService.check('c_pref')){
        let obj = JSON.parse(this.cookieService.get('c_pref'));
        obj.vimeo = onOff;
        this.cookieService.set('c_pref', JSON.stringify(obj), 365, '/');
      } else {
        let obj: {vimeo: boolean};
        obj.vimeo = onOff;
        this.cookieService.set('c_pref', JSON.stringify(obj),365, '/');
      }
    }

    if(!this.vimeo){
      this.cookieService.delete('__gads', '/', '.vimeo.com');
      this.cookieService.delete('__qca', '/', '.vimeo.com');
      this.cookieService.delete('__ssid', '/', '.vimeo.com');
      this.cookieService.delete('__zlcmid', '/', '.vimeo.com');
      this.cookieService.delete('_abexps', '/', '.vimeo.com');
      this.cookieService.delete('_fbp', '/', '.vimeo.com');
      this.cookieService.delete('_ga', '/', '.vimeo.com');
      this.cookieService.delete('_gac_UA-76641-8', '/', '.vimeo.com');
      this.cookieService.delete('_gcl_au', '/', '.vimeo.com');
      this.cookieService.delete('_gcl_aw', '/', '.vimeo.com');
      this.cookieService.delete('_gcl_dc', '/', '.vimeo.com');
      this.cookieService.delete('_gid', '/', '.vimeo.com');
      this.cookieService.delete('continuous_play_v3', '/', '.vimeo.com');
      this.cookieService.delete('has_uploaded', '/', '.vimeo.com');
      this.cookieService.delete('notification_cartasi_global_announcement', '/', '.vimeo.com');
      this.cookieService.delete('player', '/', '.vimeo.com');
      this.cookieService.delete('site_settings', '/', '.vimeo.com');
      this.cookieService.delete('vimeo', '/', '.vimeo.com');
      this.cookieService.delete('vimeo_gdpr_optin', '/', '.vimeo.com');
      this.cookieService.delete('vuid', '/', '.vimeo.com');
    }
  }

  setToken(onOff: boolean) 
  { 
    this.token = onOff; 
    if (!onOff) { localStorage.clear(); } 
    if(this.cPref){
      if(this.cookieService.check('c_pref')){
        let obj = JSON.parse(this.cookieService.get('c_pref'));
        obj.token = onOff;
        this.cookieService.set('c_pref', JSON.stringify(obj), 365, '/');
      } else {
        let obj: {token: boolean};
        obj.token = onOff;
        this.cookieService.set('c_pref', JSON.stringify(obj), 365, '/');
      }
    }
  }

  setCPref(onOff: boolean) 
  { 
    this.cPref = onOff;
    if(onOff){
        let obj: {token: boolean, google: boolean, youtube: boolean} = {token:undefined, google:undefined, youtube:undefined};
        obj.token = this.token;
        obj.google = this.google;
        obj.youtube = this.youtube;
        this.cookieService.set('c_pref', JSON.stringify(obj), 365, '/');
    } else {
      this.cookieService.delete('c_pref');
    }
  }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/my-cookie.service.ts